import { Button } from "react-bootstrap";

export const linkColumn = (props: any, linkText: string, onLinkClick: (row: any) => void) => {
    return (
        <Button size='sm' className="btn-link" variant="link" {...props} onClick={() => onLinkClick(props.row)}>
            {linkText}
        </Button>
    );
};